import { Card, CardColor } from "../../../../table/module/poker_table/poker_table_common";


const {ccclass, property} = cc._decorator;

const const_color_config = {
    [1]: 'color_black_heart',
    [2]: 'color_red_heart',
    [3]: 'color_plum',
    [4]: 'color_square',
}
//一张扑克
@ccclass
export class PokerCommonColor extends cc.Component {
    //图集
    @property(cc.SpriteAtlas)
    spriteAtlasPoker: cc.SpriteAtlas = null

    //显示的牌值
    @property(cc.Sprite)
    point:cc.Sprite = null;

    @property(cc.Sprite)
    color:cc.Sprite = null;
    
    @property(cc.Sprite)
    bigColor:cc.Sprite = null;

    //黄色
    @property(cc.Node)
    yellowSprite:cc.Node = null;

    @property(cc.Node)
    orangeSprite:cc.Node = null;

    @property(cc.Node)
    blackSprite:cc.Node = null;

    @property(cc.Node)
    bgBlackNode:cc.Node = null;

    private mCode:number;

    get code(){
        return this.mCode || 0;
    }

    set code(c:number){
        this.mCode = c;
    }

    show(){
        this.node.opacity = 255;
    }

    hide(){
        this.node.opacity = 0;
    }

    fillPoker(code:number){
        this.mCode = code;
        this.setPoker(code);
    }

    //isOrange代表结算
    showPokerState(isOrange:boolean = true){
        this.showSprite(this.orangeSprite,isOrange);
        this.showSprite(this.yellowSprite,!isOrange);
        this.showSprite(this.blackSprite,false);
    }

    //移动
    movePoker(){
        
    }

   
    reset(){
       this.showCardOnly();
    }

    //只显示card
    showCardOnly(){
        this.showSprite(this.yellowSprite,false);
        this.showSprite(this.orangeSprite,false);
        this.showSprite(this.blackSprite,false);
        this.showPoker();
        this.node.position.y = 0;
        this.node.opacity = 255;
        this.node.scale = 1;
    }

    private showSprite(sp:cc.Node,isShow:boolean){
        if (sp) {
            sp.active = isShow;
        }
    }

    //置黑当前poker
    blackPoker(){
        this.showSprite(this.yellowSprite,false);
        this.showSprite(this.orangeSprite,false);
        this.showSprite(this.blackSprite,true);
    }

    //显示背面
    showBack(){
        this.bgBlackNode.active = true;
    }

    //显示扑克
    showPoker(){
        this.setPoker(this.mCode);
    }

    protected setPoker(code: number){
        if (code != 0) {
            this.bgBlackNode.active = false;;
            let card = Card.makeCardByCode(code)
            let color = card.color;
            let point = card.index;
            this.color.spriteFrame = this.getColorSpriteFrame(color,point);
            this.point.spriteFrame = this.getPointSpriteFrame(color,point);
            this.bigColor.spriteFrame = this.getBigColorSpriteFrame(color,point);
        }
    }

    protected getSpriteFrameKeyByCode(code: number):string{
        let card = Card.makeCardByCode(code)
        let key = 'Public_';
        if (card.color == CardColor.color_red_heart || card.color == CardColor.color_square) {
            
        }

        switch(card.color){
            case CardColor.color_black_heart:
                key += 'heitao_'
                break
            case CardColor.color_red_heart:
                key += 'hongtao_'
                break
            case CardColor.color_plum:
                key += 'meihua_'
                break
            case CardColor.color_square:
                key += 'fangkuai_'
                break
        }
        return key + card.index
    }

    //点数
    private getPointSpriteFrame(color: number, point: number){
        let temp = 'black_'
        if (color == CardColor.color_red_heart || color == CardColor.color_square) {
            temp = 'red_'
        }
        let key = `point_${temp}${point}`
        return this.getSpriteFrameByName(key);
    }

    protected getColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_small`
        return this.getSpriteFrameByName(key)
    }

    
    protected getBigColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_big`
        if(point > 10){
            key = `${const_color_config[color]}_${point}`
        }
        return this.getSpriteFrameByName(key)
    }

    private getSpriteFrameByName(key: string){
        return this.spriteAtlasPoker.getSpriteFrame(key)
    }

    stopPokerAction(){
        this.node.stopAllActions();
    }
}
